module.exports = __webpack_public_path__ + "static/img/wheel-border.c4efe23f.png";